import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import ChevronToggle from '../ChevronToggle'

const Wrapper = styled.div``

const Header = styled.div<{ isOpen: boolean }>`
  margin: 0px 0px;
  padding: 5px 10px;
  border-top: 1px solid rgb(234, 234, 234);
  border-bottom: ${({ isOpen }) => (isOpen ? '1' : '0')}px solid
    rgb(234, 234, 234);
  background-color: rgb(252, 252, 252);
  display: flex;
  flex-direction: row;
  align-items: center; //flex-start;
  cursor: pointer;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  flex: 1;
`

const Content = styled.div`
  margin: 10px 10px 3px 10px;
  border-top: 0px solid rgb(234, 234, 234);
`

type TCollapsible = {
  isInitiallyExpanded?: boolean
  disableToggle?: boolean
  isHidden?: boolean
  children?: React.ReactNode
  title?: string
  unmountHiddenChild?: boolean
}
const Collapsible = (props: TCollapsible): React.ReactElement => {
  const {
    isInitiallyExpanded = false,
    disableToggle = false,
    isHidden = false,
    children,
    title,
    unmountHiddenChild = false,
  } = props

  const [isOpen, setIsOpen] = useState(isInitiallyExpanded)

  const toggle = (): void => setIsOpen(!isOpen)

  const actuallyHidden = useMemo(() => !isOpen || isHidden, [isOpen, isHidden])

  return (
    <Wrapper>
      <Header onClick={toggle} isOpen={isOpen}>
        <Title className="mr-2">{title}</Title>
        {!disableToggle && (
          <ChevronToggle isToggled={!isHidden && isOpen} size={1} />
        )}
      </Header>
      {(!actuallyHidden || !unmountHiddenChild) && (
        <Content hidden={actuallyHidden}>{children}</Content>
      )}
    </Wrapper>
  )
}

export default Collapsible
